import { makeStyles } from '@material-ui/core';

const BORDER_COLOR = '#CFF0E6';

export default makeStyles(theme => ({
  root: {
    display: 'grid',
    gap: theme.spacing(2),
  },
  input: {
    display: 'inline',
    height: 0,
    left: '-99999999999px',
    position: 'absolute',
    visibility: 'hidden',
    width: 0,
  },
  button: {
    justifySelf: 'end',
  },
  filesSection: {
    background: theme.palette.common.white,
    border: `1px solid ${BORDER_COLOR}`,
    borderRadius: 8,
    boxShadow: '0 10px 26px rgba(16, 24, 40, 0.06)',
    display: 'grid',
    overflow: 'hidden',
  },
  documentRow: {
    alignItems: 'center',
    display: 'grid',
    gap: theme.spacing(2),
    gridTemplateColumns: '1fr auto',
    padding: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr',
    },
  },
  documentInfo: {
    display: 'grid',
    gap: theme.spacing(1),
    minWidth: 0,
  },
  documentName: {
    color: theme.palette.text.primary,
    fontWeight: 700,
    wordBreak: 'break-word',
  },
  documentDescription: {
    color: theme.palette.text.secondary,
    '& p': {
      margin: 0,
    },
  },
  documentActions: {
    display: 'grid',
    gap: theme.spacing(1),
    gridAutoFlow: 'column',
    justifyContent: 'end',
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'start',
    },
  },
  emptyState: {
    color: theme.palette.text.secondary,
    padding: theme.spacing(3),
    textAlign: 'center',
  },
  error: {
    justifySelf: 'end',
  },
  descriptionCounter: {
    justifySelf: 'end',
  },
}));
